/**
 * Whiteboard configuration constants extracted from inline literals (TR9).
 *
 * Values are the empirical IST snapshot captured in T5.2; semantically
 * equivalent literals across the codebase MUST be replaced with these
 * imports without changing behavior (FC-6).
 */

/** Max snap distance for line endpoints in CSS pixels (converted to world units via zoom). */
export const SNAP_SCREEN_PX = 12;

/**
 * Clickable width of a line's stroke in world pixels — the invisible grab band
 * around the visible stroke. A thin line (1–2 px) is almost impossible to hit
 * on its own, so the hit band is deliberately much wider. The effective width
 * is `max(LINE_HIT_STROKE_PX, strokeWidth)` so a fat line stays at least as
 * grabbable as it looks.
 */
export const LINE_HIT_STROKE_PX = 24;

/**
 * Standard selection-handle look, shared by every draggable handle: white with
 * a grey-blue outline. Two sizes (Anke, 2026-09-29): the transformer's resize
 * anchors stay small (`HANDLE_SIZE_PX`); the line handles (endpoints, middle
 * segment, curve points) and the round line-docking handles on object edges are
 * larger (`LINE_HANDLE_SIZE_PX`). New line-like handles should reuse these via
 * `createSelectionHandle` / `createRoundSelectionHandle` rather than inventing
 * their own size/shape.
 */

/** Resize-anchor (transformer) square side in CSS pixels (zoom-invariant). */
export const HANDLE_SIZE_PX = 10;

/**
 * Side of a line handle square (endpoints, middle segment, curve points) and
 * diameter of a round line-docking handle, in CSS pixels (zoom-invariant).
 * Anke, 2026-09-29: raised from 10 to 14. The grab area is exactly the visible
 * handle — there is no extra invisible grab margin any more (it was 23 px).
 */
export const LINE_HANDLE_SIZE_PX = 14;

/** Fill of a handle in its resting (not-snapped) state. */
export const HANDLE_FILL = '#ffffff';

/** Outline of a handle (kept in every state). */
export const HANDLE_STROKE = '#b8c4d1';

/**
 * Fuellfarbe eines Anfassers beim Darueberfahren (Anke, 2026-07-16: #666, vorher
 * Schwarz — das war zu hart).
 *
 * Das ist der RUECKFALL. Im Browser gewinnt die CSS-Variable
 * `--o2d-handle-hover-fill` aus `whiteboard.css`, damit die Farbe ohne Eingriff
 * in den Zeichen-Code umgestellt werden kann. Beide Stellen muessen denselben
 * Ton nennen, sonst haengt die Hover-Farbe daran, ob die CSS geladen wurde —
 * `tests/unit/handle-hover-fill-sync.test.ts` haelt sie zusammen.
 */
export const HANDLE_HOVER_FILL = '#666666';

/** Hover corner trigger radius in CSS pixels. */
export const HOVER_CORNER_SCREEN_PX = 14;

/**
 * Line height (unitless, × font size) of ALL text on the board — textbox text
 * (view, edit, SVG export), checklist hotspots, sticky notes and person labels.
 * Anke, 2026-10-03: one factor everywhere, 1.2 (textboxes had 1.4, the
 * checklist hotspots 1.25, person labels 1.0).
 */
export const BOARD_TEXT_LINE_HEIGHT = 1.2;

/** World-unit offset applied when duplicating or pasting objects. */
export const DUPLICATE_OFFSET_PX = 20;

/** Minimum line length in world units below which a creation gesture is rejected. */
export const MIN_LINE_LENGTH = 5;

/** Maximum image dimension (px) used to scale pasted/dropped images on import. */
export const MAX_IMAGE_DIMENSION_PX = 600;
